import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Footer</p>
    </footer>
  );
};

export default Footer;

